import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectGeneralStation,
  selectOwnersManual,
  selectHcRequirements,
  selectSkidConstrution,
  selectPumpManifoldPiping,
  selectStationEnclosure,
  selectDropPipeComments,
  selectLevelControls,
  selectPumps,
  selectPumpDetails,
  selectWaterTreatment,
  selectInletScreen,
  selectInletStrainer,
  selectDischargeFilter,
  selectDischargeStrainer,
  selectRo,
  selectUv,
  selectFertigation,
  selectUnregulatedPower,
  selectRegulatedPower,
  selectSequenceOfOperations,
  selectElectricalOptions,
  selectTelemetry,
  selectSkyHarvester,
} from "../../../redux/selectors";
import { Row, Col } from 'react-bootstrap';
import fetchMissingJobDetails from "../../../functions/fetchMissingJobDetails";


const Comments = () => {
  const dispatch = useDispatch();
  const jobId = useSelector((state) => state.jobId.jobId);

  useEffect(() => {
    if (jobId) {
      dispatch((dispatch, getState) => fetchMissingJobDetails(dispatch, getState, jobId));
    }
  }, [jobId, dispatch]);

  // const selectedApiUrls = useMemo(
  //   () => ({
  //     generalProject: apiUrls.generalProject,
  //     generalStation: apiUrls.generalStation,
  //     ownersManual: apiUrls.ownersManual,
  //     hcRequirements: apiUrls.hcRequirements,
  //     skidConstruction: apiUrls.skidConstruction,
  //     pumpManifoldPiping: apiUrls.pumpManifoldPiping,
  //     stationEnclosure: apiUrls.stationEnclosure,
  //     dropPipeComments: apiUrls.dropPipeComments,
  //     levelControls: apiUrls.levelControls,
  //     pumps: apiUrls.pumps,
  //     waterTreatment: apiUrls.waterTreatment,
  //     inletScreen: apiUrls.inletScreen,
  //     inletStrainer: apiUrls.inletStrainer,
  //     dischargeFilter: apiUrls.dischargeFilter,
  //     dischargeStrainer: apiUrls.dischargeStrainer,
  //     roSystem: apiUrls.roSystem,
  //     uvSystem: apiUrls.uvSystem,
  //     fertigation: apiUrls.fertigation,
  //     unregulatedPower: apiUrls.unregulatedPower,
  //     regulatedPower: apiUrls.regulatedPower,
  //     sequenceOfOperations: apiUrls.sequenceOfOperations,
  //     electricalOptions: apiUrls.electricalOptions,
  //     telemetry: apiUrls.telemetry,
  //     skyHarvester: apiUrls.skyHarvester,
  //   }),
  //   [apiUrls]
  // );

  const [comments, setComments] = useState([]);

  // useEffect(() => {
  //   if (jobId) {
  //     dispatch(
  //       fetchJobDetails({
  //         jobId,
  //         apiUrls: selectedApiUrls,
  //       })
  //     );
  //   }
  // }, [jobId, dispatch, selectedApiUrls]);

  const generalStation = useSelector(selectGeneralStation);
  const ownersManual = useSelector(selectOwnersManual);
  const hcRequirements = useSelector(selectHcRequirements);
  const skidConstruction = useSelector(selectSkidConstrution);
  const pumpManifoldPiping = useSelector(selectPumpManifoldPiping);
  const stationEnclosure = useSelector(selectStationEnclosure);
  const dropPipeComments = useSelector(selectDropPipeComments);
  const levelControls = useSelector(selectLevelControls);
  const pumps = useSelector(selectPumps);
  const pumpDetails = useSelector(selectPumpDetails);
  const waterTreatment = useSelector(selectWaterTreatment);
  const inletScreen = useSelector(selectInletScreen);
  const inletStrainer = useSelector(selectInletStrainer);
  const dischargeFilter = useSelector(selectDischargeFilter);
  const dischargeStrainer = useSelector(selectDischargeStrainer);
  const roSystem = useSelector(selectRo);
  const uvSystem = useSelector(selectUv);
  const fertigation = useSelector(selectFertigation);
  const unregulatedPower = useSelector(selectUnregulatedPower);
  const regulatedPower = useSelector(selectRegulatedPower);
  const sequenceOfOperations = useSelector(selectSequenceOfOperations);
  const electricalOptions = useSelector(selectElectricalOptions);
  const telemetry = useSelector(selectTelemetry);
  const skyHarvester = useSelector(selectSkyHarvester);

  useEffect(() => {
    const selectors = {
      "General Station": generalStation,
      "Owners Manual": ownersManual,
      "HC Requirements": hcRequirements,
      "Skid Construction": skidConstruction,
      "Pump Manifold Piping": pumpManifoldPiping,
      "Station Enclosure": stationEnclosure,
      "Drop Pipe Comments": dropPipeComments,
      "Level Controls": levelControls,
      "Pumps": pumps,
      "Pump Details": pumpDetails,
      "Water Treatment": waterTreatment,
      "Inlet Screen": inletScreen,
      "Inlet Strainer": inletStrainer,
      "Discharge Filter": dischargeFilter,
      "Discharge Strainer": dischargeStrainer,
      "RO System": roSystem,
      "UV System": uvSystem,
      "Fertigation": fertigation,
      "Unregulated Power": unregulatedPower,
      "Regulated Power": regulatedPower,
      "Sequence of Operations": sequenceOfOperations,
      "Electrical Options": electricalOptions,
      "Telemetry": telemetry,
      "SkyHarvester": skyHarvester,
    };

    const newComments = [];
    for (const [table, data] of Object.entries(selectors)) {
      if (data && Array.isArray(data)) {
        data.forEach((item) => {
          const zone = item.Zone ? ` (Zone ${item.Zone})` : "";
          for (const [key, value] of Object.entries(item)) {
            if (key.toLowerCase().includes("comment") && value) {
              newComments.push({ table, zone, comment: value });
            }
          }
        });
      }
    }
    setComments(newComments);
  }, [generalStation, ownersManual, hcRequirements, skidConstruction, pumpManifoldPiping, stationEnclosure, dropPipeComments, levelControls, pumps, pumpDetails, waterTreatment, inletScreen, inletStrainer, dischargeFilter, dischargeStrainer, roSystem, uvSystem, fertigation, unregulatedPower, regulatedPower, sequenceOfOperations, electricalOptions, telemetry, skyHarvester]);

  return (
    <div className="mt-4">
      {comments.map((item, index) => (
        <Row className="mb-3 border p-3" key={index}>
          <Col className="mb-2" xs={12}>
            <span className="font-weight-bold">{item.table}</span>
            <span className="font-italic">{item.zone}</span>
          </Col>
          <Col xs={12}>{item.comment}</Col>
        </Row>
      ))}
    </div>
  );
};

export default Comments;
